// * GET =====================================

// * PATCH ===================================
export const CLIENT_ADMIN_PATCH_PLATFORM_IDENTITY = (id: number | string) =>
  `/client-admin/platform_identity/${id}`;

// * POST ====================================
export const CLIENT_ADMIN_POST_ROLES = `/client-admin/roles`;

export const CLIENT_ADMIN_POST_USER_GROUPS = `/client-admin/user_groups`;

export const CLIENT_ADMIN_POST_COMPANIES = `/client-admin/companies`;

export const CLIENT_ADMIN_POST_SCHEDULES = `/client-admin/schedules`;

export const CLIENT_ADMIN_POST_PLATFORM_IDENTITIES = `/client-admin/platform_identities`;

export const CLIENT_ADMIN_POST_USERS = `/client-admin/users`;

export const CLIENT_ADMIN_POST_USER_ACTION_LOGS = `/client-admin/user_action_logs`;

export const CLIENT_ADMIN_POST_USER_ACTION_STATS_DAILY_ACTIVE_USERS = `/client-admin/user_action_stats_daily_active_users`;

export const CLIENT_ADMIN_POST_USER_ACTION_STATS_TOP_ACTIVE_COMPANIES = `/client-admin/user_action_stats_top_active_companies`;

export const CLIENT_ADMIN_POST_USER_ACTION_STATS_ERRORS_PER_DAY = `/client-admin/user_action_stats_errors_per_day`;
/** Top User Action Types (WAP-1762): the action types ranked by count within the range, categories = type names. */
export const CLIENT_ADMIN_POST_USER_ACTION_STATS_TOP_ACTION_TYPES = `/client-admin/user_action_stats_top_action_types`;
// * DELETE ==================================

// * PUT =====================================
